import responsiveSize from 'helper/responsiveSize'
import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IActionCard {
  tag?: string
  disabled?: boolean
}

export default styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  background: ${(props: IActionCard & { theme: any }) => {
    if (props.disabled) return `${Theme.pallete.SECONDARY2}`
    return props.theme.colors.primary
  }};

  width: 144px;
  height: 112px;
  padding: ${(props: IActionCard) => {
    if (props.tag) return `34px 0 16px 15px`
    return `49px 0 16px 15px`
  }};

  border-radius: 5px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
  cursor: ${(props: IActionCard) => {
    if (props.disabled) return ''
    return 'pointer'
  }};
  @media only screen and (min-width: 1441px) {
    height: 128px;
    width: 162px;
  }
  .ac-icon {
    width: 21px;
    height: 21px;

    filter: ${(props: IActionCard & { theme: any }) => {
      if (props.disabled) return `${Theme.icons.PRIMARY}`
      return props.theme.filters.primaryIcon
    }};
  }

  .ac-title {
    color: ${(props: IActionCard & { theme: any }) => {
      if (props.disabled) return `${Theme.pallete.QUATERNARY}`
      return props.theme.colors.primaryBtnTxt
    }};
    font-family: ${Theme.fontFamily.SECONDARY};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    @media only screen and (min-width: 1441px) {
      font-size: 13px;
    }
  }

  .ac-tag {
    display: inline-flex;
    justify-content: center;
    align-items: center;

    gap: 7.5px;
    position: relative;
    bottom: 30px;
    left: 64px;

    max-width: 42px;
    max-height: 13px;

    border-radius: 5px;

    font-size: ${responsiveSize.responsiveWidth(
      Theme.sizes.CARDS.FONT.TERTIARY
    )};
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.1px;

    padding: ${`${responsiveSize.responsiveWidth(
      Theme.sizes.CARDS.PADDING.QUINARY
    )} ${responsiveSize.responsiveWidth(Theme.sizes.CARDS.PADDING.SENARY)}`};

    color: ${Theme.pallete.SECONDARY};
    background: ${Theme.pallete.QUINARY};
  }
`
